/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown>, total: NonNullable<unknown> }} Flagship_Onboarding_Step_CountInputs */

const en_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.step} of ${i?.total}`)
};

const de_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schritt ${i?.step} von ${i?.total}`)
};

const pt_br2_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Etapa ${i?.step} de ${i?.total}`)
};

const tr_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adım ${i?.step}/${i?.total}`)
};

const zh_cn2_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.step} 步，共 ${i?.total} 步`)
};

const zh_hk2_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.step} 步，共 ${i?.total} 步`)
};

const ko_kr2_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total}단계 중 ${i?.step}단계`)
};

const ru_ru2_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Шаг ${i?.step} из ${i?.total}`)
};

const es_419_flagship_onboarding_step_count = /** @type {(inputs: Flagship_Onboarding_Step_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paso ${i?.step} de ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Step {step} of {total}" |
*
* @param {Flagship_Onboarding_Step_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const flagship_onboarding_step_count = /** @type {((inputs: Flagship_Onboarding_Step_CountInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flagship_Onboarding_Step_CountInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flagship_onboarding_step_count(inputs)
	if (locale === "de") return de_flagship_onboarding_step_count(inputs)
	if (locale === "pt-BR") return pt_br2_flagship_onboarding_step_count(inputs)
	if (locale === "tr") return tr_flagship_onboarding_step_count(inputs)
	if (locale === "zh-CN") return zh_cn2_flagship_onboarding_step_count(inputs)
	if (locale === "zh-HK") return zh_hk2_flagship_onboarding_step_count(inputs)
	if (locale === "ko-KR") return ko_kr2_flagship_onboarding_step_count(inputs)
	if (locale === "ru-RU") return ru_ru2_flagship_onboarding_step_count(inputs)
	return es_419_flagship_onboarding_step_count(inputs)
});